import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumFormatter',
  standalone: true
})
export class EnumFormatterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    // Convert SCREAMING_SNAKE_CASE to Title Case
    // Example: READY_TO_MERCHANT -> Ready To Merchant
    return value
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
